import { type FC, useEffect } from "react";
import { Blac } from "blac-next";
import translate from "src/lib/translate";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";
import InitialLabsFlow from "src/ui/components/InitialLabsFlow/InitialLabsFlow";
import { AppQueryPopupsController } from "../../AppQueryPopupsBloc";
import AppointmentsBloc from "src/state/AppointmentsBloc/AppointmentsBloc";

const InitialLabDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();

  useEffect(() => {
    return () => {
      void Blac.getBloc(AppointmentsBloc).loadAppointments();
    };
  }, []);

  const onClose = () => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  };

  return (
    <InDialog
      width="min(calc(100% - 4rem), 120rem)"
      height="min(calc(100% - 4rem), 70rem)"
      padding="none"
      popup
      title={translate("task.consolidated_review_lab_status")}
      returnUrl={returnUrl}
      onClose={onClose}
    >
      <InitialLabsFlow />
    </InDialog>
  );
};

export default InitialLabDialog;
